import { Injectable } from '@angular/core';

import { RestService } from "../../../../core/services/rest.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { MaterialEspecificacao } from "./material-especificacao.model";
import {
    materiaisRouter, materialEspecificacaoRouter, materialEspecificacaoApi,
    materialEspecificacaoStorageName
} from "../../material/shared/data.service";
import { almoxarifadoRoute } from "../../../shared/data.service";
import { newRoute, editRoute } from "../../../../shared/services/data.service";

@Injectable()
export class MaterialEspecificacaoService {
    private apiUrl: string = materialEspecificacaoApi;
    private storageName: string = materialEspecificacaoStorageName;

    constructor(
        private _restService: RestService,
        private _authService: AuthService
    ){}

    public onPost(object: MaterialEspecificacao, done: any) {
        this._restService.onPost(this.apiUrl, object, done);
    }

    public onPut(object: MaterialEspecificacao, done: any) {
        this._restService.onPut(this.apiUrl, object, done);
    }

    public onDelete(objectId: number, done: any) {
        this._restService.onDelete(this.apiUrl, objectId, done);
    }

    public onGetbyMaterial(materialId: number, done: any) {
        var filter: any = {"order":"descricao","where":{"materialId":materialId}};
        this._restService.onGetPost(this.apiUrl, filter, done);
    }

    public onGetById(objectId: number, done: any) {
        var filter: any = {"include":"material"};
        this._restService.onGetPostId(this.apiUrl, objectId, filter, done);
    }

    //storage
    public setStorage(item: MaterialEspecificacao) {
        var object: string = JSON.stringify(item);
        localStorage.setItem(this.storageName + '-selected', object);
    }

    public getStorage() {
        var item: string = localStorage.getItem(this.storageName + "-selected");
        return JSON.parse(item);
    }

    //session
    public setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(this.storageName + '-new', object);
    }

    public getSessionStorage() {
        var item: string = sessionStorage.getItem(this.storageName + "-new");
        return JSON.parse(item);
    }

    //router
    public goToList() {
        var router: string =  almoxarifadoRoute + '/' + materiaisRouter + '/' + materialEspecificacaoRouter;
        this._authService.navigateTo(router);
    }

    public goToAdd() {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialEspecificacaoRouter + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    public goToEdit(objectId: number) {
        var router: string = almoxarifadoRoute + '/' + materiaisRouter + '/' + materialEspecificacaoRouter + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    //others
    //qndo retorna para continuar o cadastro, caso tenha ido para outro formulario
    returnToForm() {
        var session: any = this.getSessionStorage();
        if (session && session.id) {
            this.goToEdit(session.id);
        } else {
            this.goToAdd();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-especificacao/shared/material-especificacao.service.ts
 **/